module.exports = __webpack_public_path__ + "static/media/model-pathfinder-r50.1f5aaa1f.jpg";